import React, { Component } from "react";
import { connect } from "react-redux";
import { createPriceAlert, getAirport } from "../../shared/requests-api";
import moment from "moment";
import { getUser } from "../../vanilla/userUtils";
import { decorateSearch } from "../searchform/utils/airport-replacers";
import { $, formatCurrency } from "../../shared/utils";
import PubSub from "pubsub-js";
import "../../shared/pubsub-triggers";
import { Tooltip } from "react-tippy";

class PriceAlertModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			city: props.city || {
				from: {
					city: ""
				},
				to: {
					city: ""
				}
			},
			outboundDate: this.props.searchParams["outboundDate"],
			outboundFlexDate: false,
			outboundStops: [],
			outboundTime: [],
			inboundDate: this.props.searchParams["inboundDate"],
			inboundFlexDate: false,
			inboundStops: [],
			inboundTime: [],
			closeModal: props.closeModal,
			results: [],
			origins: [],
			destinations: [],
			valueInput: "",
			validateInput: "",
			closeParada: false,
			passenger:
				this.props.searchParams["adults"] +
				this.props.searchParams["children"] +
				this.props.searchParams["infants"],
			adults: this.props.searchParams["adults"],
			cabin: this.props.searchParams["cabin"],
			children: this.props.searchParams["children"],
			infants: this.props.searchParams["infants"],
			hiddenCreateStep: true,
			canOpenModal: false,
			emailError: false,
		};

		this.searching = null;

		this.setCity = this.setCity.bind(this);
		this.renderResult = this.renderResult.bind(this);
		this.renderResults = this.renderResults.bind(this);
		this.search = this.search.bind(this);
		this.createAlert = this.createAlert.bind(this);
	}

	validate() {
		const inputPriceAlert = $("#price-alert-email");
		const parse_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if (!parse_email.test(this.state.validateInput)) {
			inputPriceAlert.parentNode.classList.add("has-error");
			this.setState({ emailError: true });
			return false;
		} else {
			inputPriceAlert.parentNode.classList.remove("has-error");
			this.setState({ emailError: false });
			return true;
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.city === undefined && this.props.city !== null) {
			this.setState({ city: this.props.city });
		}

		if (!prevProps.canOpenModal && this.props.canOpenModal) {
			this.setFilterParameters();
		}
	}

	setCity(origin) {
		if (this.state.showInputOrigin) {
			const origins = this.state.origins;
			origins.push(origin);
			this.setState({ results: null, showInputOrigin: false, origins: origins, valueInput: "" });
		} else {
			const destinations = this.state.destinations;
			destinations.push(origin);
			this.setState({
				results: null,
				showInputDestinations: false,
				destinations: destinations,
				valueInput: ""
			});
		}
	}

	renderResult(result, i) {
		const { city, name, iata } = result;
		const { term } = this.state;
		let str = decorateSearch(term, `${city} - ${name} (${iata})`);

		return (
			<div
				onClick={() => this.setCity(result)}
				key={i}
				className="city-selector__result"
				dangerouslySetInnerHTML={{ __html: str }}
			/>
		);
	}

	renderResults(cities) {
		if (!cities) {
			return null;
		}

		let results = cities;

		const exists = [this.state.city.from, this.state.city.to];
		if (this.state.origins) {
			this.state.origins.map(airport => {
				exists.push(airport);
			});
		}

		if (this.state.destinations) {
			this.state.destinations.map(airport => {
				exists.push(airport);
			});
		}

		results = results.filter(result => {
			for (let i = 0; i < exists.length; i++) {
				if (exists[i].iata === result.iata) {
					return false;
				}
			}

			return true;
		});

		return <div className="city-selector__result-group">{results.map(this.renderResult)}</div>;
	}

	search(event) {
		const value = event.target.value;
		this.setState({ valueInput: value });
		if (value.length < 3) {
			return this.setState({ results: null });
		}

		getAirport(encodeURIComponent(value)).then(returnApi => {
			if (returnApi.status === 200) {
				this.setState({ results: returnApi.data, term: value });
			}
		});
	}

	changeParameterArray(arr, prop) {
		const idx = arr.indexOf(prop);

		if (idx === -1) {
			arr.push(prop);
		} else {
			arr.splice(idx, 1);
		}

		return arr.sort();
	}

	getSelectedTimesFromFilter(times) {
		const selected = [];

		if (times.indexOf("madrugada") !== -1) {
			selected.push("dawn");
		}

		if (times.indexOf("manha") !== -1) {
			selected.push("morning");
		}

		if (times.indexOf("tarde") !== -1) {
			selected.push("afternoon");
		}

		if (times.indexOf("noite") !== -1) {
			selected.push("night");
		}

		return selected.length === 4 ? [] : selected;
	}

	formatTimes(times, ga = false) {
		if (times.length === 0) {
			return ga ? "Horário (Todos)" : "Todos";
		}

		const timesName = [];

		if (times.indexOf("dawn") !== -1) {
			timesName.push(ga ? "Horário (Madrugada)" : "Madrugada");
		}

		if (times.indexOf("morning") !== -1) {
			timesName.push(ga ? "Horário (Manhã)" : "Manhã");
		}

		if (times.indexOf("afternoon") !== -1) {
			timesName.push(ga ? "Horário (Tarde)" : "Tarde");
		}

		if (times.indexOf("night") !== -1) {
			timesName.push(ga ? "Horário (Noite)" : "Noite");
		}

		return timesName.length === 4 ? (ga ? "Horário (Todos)" : "Todos") : timesName.join(", ");
	}

	createAlert() {
		const user = getUser();
		const from = this.state.city.from.iata;
		const to = this.state.city.to.iata;

		if (!user && !this.validate()) {
			return;
		}

		const isMobile = window.isMobileDevice();

		const send = {
			from: from,
			to: to,
			tripType: this.props.searchParams.tripType,
			outboundDate: this.state.outboundDate,
			outboundFlexDate: this.state.outboundFlexDate,
			outboundStops: this.state.outboundStops.length ? this.state.outboundStops : null,
			outboundTime: this.state.outboundTime.length ? this.state.outboundTime : null,
			adults: this.state.adults,
			children: this.state.children,
			cabin: this.state.cabin,
			infants: this.state.infants,
			targetPrice: this.props.value,
			origin: isMobile ? "MM-SITE-MOBILE" : "MM-SITE-DESKTOP"
		};

		if (this.state.inboundDate) {
			send.inboundDate = this.state.inboundDate;
			send.inboundFlexDate = this.state.inboundFlexDate;
			send.inboundStops = this.state.inboundStops.length ? this.state.inboundStops : null;
			send.inboundTime = this.state.inboundTime.length ? this.state.inboundTime : null;
		}

		if (user) {
			send.user = {
				idMM: parseInt(user.id),
				name: user.name,
				email: user.email
			};
		} else {
			send.user = {
				email: $("#price-alert-email").value.trim()
			};
		}

		const $btn = $(".btn-price-alert-modal");
		$btn.classList.add("disabled");
		$btn.disabled=true;
		$btn.querySelector(".loader").classList.remove("hidden");

		createPriceAlert(send)
			.then(() => {
				this.setState({
					hiddenCreateStep: !this.state.hiddenCreateStep
				});

				this.sendDitoEvents(send);
				this.sendGAEvents();

				window.hj=window.hj||function(){(hj.q=hj.q||[]).push(arguments)};
				hj('trigger', 'enquete-alerta-motivo-cadastro');
				
				$btn.querySelector(".loader").classList.add("hidden");
			})
			.catch(() => {
				$btn.classList.remove("disabled");
				$btn.disabled=false;
				$btn.querySelector(".loader").classList.add("hidden");
			});
	}

	sendDitoEvents(alert) {
		const { user, ...rest } = alert;

		PubSub.publish("dataLayer", {
			event: "ditoIdentifyEmail",
			ditoIdentify: {
				email: user.email
			}
		});

		PubSub.publish("dataLayer", {
			event: "ditoTrack",
			ditoTrack: {
				action: "criou-alerta-de-preco",
				data: rest
			}
		});
	}

	sendGAEvents() {
		PubSub.publish("dataLayer", { event: "gaEvent", gaEventCategory: "Resultados de busca", gaEventAction: "Alerta de preço", gaEventLabel: "Cadastro de alerta", gaEventValue: "" });
	}

	setFilterParameters() {
		const { selectedFilters } = this.props;

		if (selectedFilters.outbound) {
			this.setState({
				outboundStops: this.getSelectedStopsFromFilter(selectedFilters.outbound.stops),
				outboundTime: this.getSelectedTimesFromFilter(selectedFilters.outbound.departureTimes)
			});
		}

		if (selectedFilters.inbound) {
			this.setState({
				inboundStops: this.getSelectedStopsFromFilter(selectedFilters.inbound.stops),
				inboundTime: this.getSelectedTimesFromFilter(selectedFilters.inbound.departureTimes)
			});
		}
	}

	getSelectedStopsFromFilter(stops) {
		let result = [];

		if (stops.length > 0) {
			result = stops.map(stop => {
				return stop === "direct" ? 0 : stop;
			});
		}

		return result.sort();
	}

	formatStops(stops, ga = false) {
		if (stops.length === 0) {
			return ga ? "Paradas (Todos)" : "Todos";
		}

		const stopsName = stops.map(stop => stop === 0 ? (ga ? "Paradas (Direto)" : "Voo direto") : (ga ? `Paradas (${stop})` : `${stop} parada(s)`));

		return stopsName.length === 4 ? (ga ? "Paradas (Todos)" : "Todos") : stopsName.join(", ");
	}

	render() {
		const { results } = this.state;
		const user = getUser();

		return (
			<div
				className="tingle-modal-box"
				onClick={() => {
					if (
						this.state.showSelectParadaIda ||
						this.state.showSelectParadaVolta ||
						this.state.showSelectHorarioIda ||
						this.state.showSelectHorarioVolta
					) {
						this.setState({
							showSelectParadaIda: false,
							showSelectParadaVolta: false,
							showSelectHorarioIda: false,
							showSelectHorarioVolta: false
						});
					}
				}}
			>
				<div
					className="price-alert-modal price-alert-modal--form"
					hidden={!this.state.hiddenCreateStep}
				>
					<div className="price-alert-modal-header modal-header-wrapper modal-header-wrapper--centered">
						<h4>Vamos configurar o seu alerta!</h4>
					</div>
					<div className="price-alert-modal-content">
						<div className="form-texto">
							<div className="well text-center">
								<p className="small no-margin">
									Você irá receber alertas de preço com valores abaixo de {" "}
									<strong className="text-info">{this.props.value ? formatCurrency(this.props.value) : <i className="loader loader-fetching" />}</strong>
									<br/>
									Valor incluindo <strong className="text-info">{this.state.passenger}</strong> passageiro{this.state.passenger > 1 ? "s" : ""} e taxas.
								</p>
							</div>
						</div>
						<div className="searched-flight-wrapper">
							<div className="row">
								<div className="col-xs-16 col-md-8">
									<div className="form-group">
										<label className="form-label">Saindo de</label>
										<div className="form-control no-margin disabled no-shadow">
											{this.state.city.from.city} - {this.state.city.from.name} ({
												this.state.city.from.iata
											})
										</div>
										<i className="icon-pin form-control-feedback"></i>
									</div>
								</div>
								<div className="col-xs-16 col-md-8">
									<div className="form-group">
										<label className="form-label">Indo para</label>
										<div className="form-control no-margin disabled no-shadow">
											{this.state.city.to.city} - {this.state.city.to.name} ({
												this.state.city.to.iata
											})
										</div>
										<i className="icon-pin form-control-feedback"></i>
									</div>
								</div>
							</div>
							<div className="city-selector__results-wrapper city-selector-to">
								{results && this.renderResults(results)}
							</div>
						</div>
						<div className="form-data">
							<div className="outbound">
								<div className="d-flex">
									<div className="flight-stretch">
										<span className="flight__data flight__data_stretch">
											<i className="icon-outbound" />
											IDA
										</span>
										<span className="flight__data flight__data_trip">
											{moment(this.state.outboundDate).format("DD/MM/YYYY")}
										</span>
									</div>
									<div className="checkbox hidden">
										<input
											type="checkbox"
											className="styled-checkbox"
											id="checkbox-data-ida"
											value={this.state.outboundFlexDate}
											onChange={() =>
												this.setState({ outboundFlexDate: !this.state.outboundFlexDate })
											}
										/>
										<label htmlFor="checkbox-data-ida" className="form-label no-margin no-bold">
											Data flexível
										</label>
										<Tooltip
											className="helper"
											html={(
												<p className="no-margin">Ao habilitar a data flexível você nos permite procurar voos em um intervalo de 1 dia antes ou depois da data de ida e/ou volta selecionadas. Isso aumenta a possibilidade de encontrar uma combinação com melhor preço!</p>
											)}
											position="bottom"
											arrow={true}
										>
											<i className="tooltip">?</i>
										</Tooltip>
									</div>
								</div>
								<div className="row">
									<div className="col-xs-8 v-center-columns">
										<div className="form-group no-margin">
											<label className="form-label no-bold">Paradas</label>
											<div
												className="select-fake form-control no-shadow no-margin no-bold"
												onClick={() => {
													this.setState({
														closeParada: true,
														showSelectParadaIda: !this.state.showSelectParadaIda,
														showSelectParadaVolta: false,
														showSelectHorarioIda: false,
														showSelectHorarioVolta: false
													});
												}}
											>
												<span>{this.formatStops(this.state.outboundStops)}</span>
												<i className="icon-arrow-down form-control-feedback"></i>
											</div>
											<div
												className={`select-fake-options ${
													this.state.showSelectParadaIda ? "" : "hide"
													}`}
											>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														id="checkbox-stops-outbound-straight"
														onChange={() =>
															this.setState({
																outboundStops: this.changeParameterArray(this.state.outboundStops, 0),
																showSelectParadaIda: !this.state.showSelectParadaIda
															})
														}
														checked={this.state.outboundStops.indexOf(0) !== -1}
													/>
													<label htmlFor="checkbox-stops-outbound-straight" className="selected">
														Voo direto
													</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														id="checkbox-stops-outbound-one"
														onChange={() =>
															this.setState({
																outboundStops: this.changeParameterArray(this.state.outboundStops, 1),
																showSelectParadaIda: !this.state.showSelectParadaIda
															})
														}
														checked={this.state.outboundStops.indexOf(1) !== -1}
													/>
													<label htmlFor="checkbox-stops-outbound-one" className="selected">
														1 Parada
													</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														id="checkbox-stops-outbound-two"
														onChange={() =>
															this.setState({
																outboundStops: this.changeParameterArray(this.state.outboundStops, 2),
																showSelectParadaIda: !this.state.showSelectParadaIda
															})
														}
														checked={this.state.outboundStops.indexOf(2) !== -1}
													/>
													<label htmlFor="checkbox-stops-outbound-two" className="selected">
														2 Paradas
													</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														id="checkbox-stops-outbound-three"
														onChange={() =>
															this.setState({
																outboundStops: this.changeParameterArray(this.state.outboundStops, 3),
																showSelectParadaIda: !this.state.showSelectParadaIda
															})
														}
														checked={this.state.outboundStops.indexOf(3) !== -1}
													/>
													<label htmlFor="checkbox-stops-outbound-three" className="selected">
														3 Paradas
													</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														id="checkbox-stops-outbound-all"
														onChange={() =>
															this.setState({
																outboundStops: [],
																showSelectParadaIda: !this.state.showSelectParadaIda
															})
														}
														checked={this.state.outboundStops.length === 0}
													/>
													<label htmlFor="checkbox-stops-outbound-all" className="selected">
														Todos
													</label>
												</div>
											</div>
										</div>
									</div>
									<div className="col-xs-8 v-center-columns">
										<div className="form-group no-margin">
											<label className="form-label no-bold">Horário de partida</label>
											<div
												className="select-fake form-control no-shadow no-margin no-bold"
												onClick={() => {
													this.setState({
														showSelectHorarioIda: !this.state.showSelectHorarioIda,
														showSelectParadaVolta: false,
														showSelectParadaIda: false,
														showSelectHorarioVolta: false
													});
												}}
											>
												<span className="text-times">
													{this.formatTimes(this.state.outboundTime)}
												</span>
												<i className="icon-arrow-down form-control-feedback"></i>
											</div>
											<div
												className={`select-fake-options ${
													this.state.showSelectHorarioIda ? "" : "hide"
													}`}
											>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														checked={this.state.outboundTime.indexOf("dawn") !== -1}
														id="checkbox-horario-ida-madrugada"
														onChange={() =>
															this.setState({
																outboundTime: this.changeParameterArray(this.state.outboundTime, "dawn"),
																showSelectHorarioIda: !this.state.showSelectHorarioIda
															})
														}
													/>
													<label htmlFor="checkbox-horario-ida-madrugada" className="selected">
														Madrugada
												</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														checked={this.state.outboundTime.indexOf("morning") !== -1}
														id="checkbox-horario-ida-manha"
														onChange={() =>
															this.setState({
																outboundTime: this.changeParameterArray(
																	this.state.outboundTime,
																	"morning"
																),
																showSelectHorarioIda: !this.state.showSelectHorarioIda
															})
														}
													/>
													<label htmlFor="checkbox-horario-ida-manha" className="selected">
														Manhã
												</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														checked={this.state.outboundTime.indexOf("afternoon") !== -1}
														id="checkbox-horario-ida-tarde"
														onChange={() =>
															this.setState({
																outboundTime: this.changeParameterArray(
																	this.state.outboundTime,
																	"afternoon"
																),
																showSelectHorarioIda: !this.state.showSelectHorarioIda
															})
														}
													/>
													<label htmlFor="checkbox-horario-ida-tarde" className="selected">
														Tarde
												</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														checked={this.state.outboundTime.indexOf("night") !== -1}
														id="checkbox-horario-ida-noite"
														onChange={() =>
															this.setState({
																outboundTime: this.changeParameterArray(this.state.outboundTime, "night"),
																showSelectHorarioIda: !this.state.showSelectHorarioIda
															})
														}
													/>
													<label htmlFor="checkbox-horario-ida-noite" className="selected">
														Noite
												</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														checked={!this.state.outboundTime.length}
														id="checkbox-horario-ida-todos"
														onChange={() =>
															this.setState({
																outboundTime: [],
																showSelectHorarioIda: !this.state.showSelectHorarioIda
															})
														}
													/>
													<label htmlFor="checkbox-horario-ida-todos" className="selected">
														Todos
												</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className={`${this.state.inboundDate ? "inbound" : "hide"}`}>
								<div className="d-flex">
									<div className="flight-stretch">
										<span className="flight__data flight__data_stretch">
											<i className="icon-inbound" />
											VOLTA
											</span>
										<span className="flight__data flight__data_trip">
											{moment(this.state.inboundDate).format("DD/MM/YYYY")}
										</span>
									</div>
									<div className="checkbox hidden">
										<input
											type="checkbox"
											className="styled-checkbox"
											id="checkbox-data-volta"
											value={this.state.inboundFlexDate}
											onChange={() =>
												this.setState({ inboundFlexDate: !this.state.inboundFlexDate })
											}
										/>
										<label htmlFor="checkbox-data-volta" className="form-label no-margin no-bold">
											Data flexível
										</label>
										<Tooltip
											className="helper"
											html={(
												<p className="no-margin">Ao habilitar a data flexível você nos permite procurar voos em um intervalo de 1 dia antes ou depois da data de ida e/ou volta selecionadas. Isso aumenta a possibilidade de encontrar uma combinação com melhor preço!</p>
											)}
											position="bottom"
											arrow={true}
										>
											<i className="tooltip">?</i>
										</Tooltip>
									</div>
								</div>
								<div className="row">
									<div className="col-xs-8 v-center-columns">
										<div className="form-group no-margin">
											<label className="form-label no-bold">Paradas</label>
											<div
												className="select-fake form-control no-shadow no-margin no-bold"
												onClick={() => {
													this.setState({
														showSelectParadaVolta: !this.state.showSelectParadaVolta,
														showSelectParadaIda: false,
														showSelectHorarioIda: false,
														showSelectHorarioVolta: false
													});
												}}
											>
												<span>{this.formatStops(this.state.inboundStops)}</span>
												<i className="icon-arrow-down form-control-feedback"></i>
											</div>
											<div
												className={`select-fake-options ${
													this.state.showSelectParadaVolta ? "" : "hide"
													}`}
											>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														id="checkbox-parada-volta-direto"
														onChange={() =>
															this.setState({
																inboundStops: this.changeParameterArray(this.state.inboundStops, 0),
																showSelectParadaVolta: !this.state.showSelectParadaVolta
															})
														}
														checked={this.state.inboundStops.indexOf(0) !== -1}
													/>
													<label htmlFor="checkbox-parada-volta-direto" className="selected">
														Voo direto
													</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														id="checkbox-stops-inbound-one"
														onChange={() =>
															this.setState({
																inboundStops: this.changeParameterArray(this.state.inboundStops, 1),
																showSelectParadaVolta: !this.state.showSelectParadaVolta
															})
														}
														checked={this.state.inboundStops.indexOf(1) !== -1}
													/>
													<label htmlFor="checkbox-stops-inbound-one" className="selected">
														1 Parada
													</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														id="checkbox-stops-inbound-two"
														onChange={() =>
															this.setState({
																inboundStops: this.changeParameterArray(this.state.inboundStops, 2),
																showSelectParadaVolta: !this.state.showSelectParadaVolta
															})
														}
														checked={this.state.inboundStops.indexOf(2) !== -1}
													/>
													<label htmlFor="checkbox-stops-inbound-two" className="selected">
														2 Paradas
													</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														id="checkbox-stops-inbound-three"
														onChange={() =>
															this.setState({
																inboundStops: this.changeParameterArray(this.state.inboundStops, 3),
																showSelectParadaVolta: !this.state.showSelectParadaVolta
															})
														}
														checked={this.state.inboundStops.indexOf(3) !== -1}
													/>
													<label htmlFor="checkbox-stops-inbound-three" className="selected">
														3 Paradas
													</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														id="checkbox-stops-inbound-all"
														onChange={() =>
															this.setState({
																inboundStops: [],
																showSelectParadaVolta: !this.state.showSelectParadaVolta
															})
														}
														checked={this.state.inboundStops.length === 0}
													/>
													<label htmlFor="checkbox-stops-inbound-all" className="selected">
														Todos
													</label>
												</div>
											</div>
										</div>
									</div>
									<div className="col-xs-8 v-center-columns">
										<div className="form-group no-margin">
											<label className="form-label no-bold">Horário de partida</label>
											<div
												className="select-fake form-control no-shadow no-margin no-bold"
												onClick={() => {
													this.setState({
														showSelectHorarioVolta: !this.state.showSelectHorarioVolta,
														showSelectHorarioIda: false,
														showSelectParadaIda: false,
														showSelectParadaVolta: false
													});
												}}
											>
												<span className="text-times">{this.formatTimes(this.state.inboundTime)}</span>
												<i className="icon-arrow-down form-control-feedback"></i>
											</div>
											<div
												className={`select-fake-options ${
													this.state.showSelectHorarioVolta ? "" : "hide"
													}`}
											>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														checked={this.state.inboundTime.indexOf("dawn") !== -1}
														id="checkbox-horario-volta-madrugada"
														onChange={() =>
															this.setState({
																inboundTime: this.changeParameterArray(this.state.inboundTime, "dawn"),
																showSelectHorarioVolta: !this.state.showSelectHorarioVolta
															})
														}
													/>
													<label htmlFor="checkbox-horario-volta-madrugada" className="selected">
														Madrugada
														</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														checked={this.state.inboundTime.indexOf("morning") !== -1}
														id="checkbox-horario-volta-manha"
														onChange={() =>
															this.setState({
																inboundTime: this.changeParameterArray(this.state.inboundTime, "morning"),
																showSelectHorarioVolta: !this.state.showSelectHorarioVolta
															})
														}
													/>
													<label htmlFor="checkbox-horario-volta-manha" className="selected">
														Manhã
														</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														checked={this.state.inboundTime.indexOf("afternoon") !== -1}
														id="checkbox-horario-volta-tarde"
														onChange={() =>
															this.setState({
																inboundTime: this.changeParameterArray(
																	this.state.inboundTime,
																	"afternoon"
																),
																showSelectHorarioVolta: !this.state.showSelectHorarioVolta
															})
														}
													/>
													<label htmlFor="checkbox-horario-volta-tarde" className="selected">
														Tarde
														</label>
												</div>
												<div className="checkbox">
													<input
														type="checkbox"
														className="styled-checkbox"
														checked={this.state.inboundTime.indexOf("night") !== -1}
														id="checkbox-horario-volta-noite"
														onChange={() =>
															this.setState({
																inboundTime: this.changeParameterArray(this.state.inboundTime, "night"),
																showSelectHorarioVolta: !this.state.showSelectHorarioVolta
															})
														}
													/>
													<label htmlFor="checkbox-horario-volta-noite" className="selected">
														Noite
														</label>
												</div>
												<div className="checkbox">
													<input
														type="radio"
														className="styled-checkbox"
														checked={!this.state.inboundTime.length}
														id="checkbox-horario-volta-todos"
														onChange={() =>
															this.setState({
																inboundTime: [],
																showSelectHorarioVolta: !this.state.showSelectHorarioVolta
															})
														}
													/>
													<label htmlFor="checkbox-horario-volta-todos" className="selected">
														Todos
														</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className={`form-email ${user ? "hide" : ""}`}>
							<div className={`alert alert-danger ${this.state.emailError ? "" : "hide"}`}>
								<div className="alert--icon">
									<i className="icon-exclamation"></i>
								</div>
								<div className="alert--message">
									<p>
										<strong>Insira um e-mail válido.</strong>{" "}
									</p>
								</div>
							</div>
							<div className="form-group">
								<i className="icon-email form-control-feedback" />
								<label className="form-label" htmlFor="price-alert-email">Digite seu e-mail</label>
								<input
									id="price-alert-email"
									type="email"
									required
									name="price-alert-email"
									className="price-alert-input-email form-control no-shadow"
									contentEditable="true"
									aria-required="true"
									placeholder="Deixe aqui o e-mail que mais usa"
									aria-label="Deixe aqui o e-mail que mais usa"
									onChange={event => {
										this.setState({
											validateInput: event.target.value
										});
									}}
									onBlur={event => {
										this.validate();
									}}
								/>
							</div>
						</div>						
					</div>
					<div className="price-alert-modal-footer">
						<button
							//data-action="price-alert-register"
							className="btn btn-success btn-price-alert-modal"
							onClick={() => {
								this.createAlert();
							}}
						>
							<i className="loader loader-fetching hidden" />
							Criar alerta
								</button>
						<button className="btn btn-default" onClick={() => this.state.closeModal()}>
							Cancelar
						</button>
					</div>
				</div>
				<div className="price-alert-modal price-alert-modal--confirmation" hidden={this.state.hiddenCreateStep}>
					<div className="price-alert-modal-header modal-header-wrapper">
						<h4>Já estamos procurando seu voo!</h4>
					</div>
					<div className="price-alert-modal-content">
						<p>Relaxe e deixe com a gente. Você será avisado quando houver novas oportunidades disponíveis.</p>
						<p>Esse alerta pode ser cancelado a qualquer momento através dos e-mails relacionados.</p>
						<p><strong className="text-info">Continue pesquisando</strong>, sempre temos boas oportunidades para você!</p>
						<button
							type="submit"
							name="button"
							className="btn btn btn-success"
							onClick={() => {
								this.setState({
									hiddenCreateStep: !this.state.hiddenCreateStep
								});
								this.state.closeModal();
							}}
						>
							Fechar
						</button>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	searchParams: state.searchParams.params,
	selectedFilters: state.selectedFilters
});

export default connect(mapStateToProps)(PriceAlertModal);
